<template>
  <el-dialog v-draggable :close-on-click-modal="false" :close-on-press-escape="false" append-to-body
    :before-close="handleClose" :visible.sync="imgPoint" title="审图要点" width="687px">
    <div v-loading="loadPage" class="box">
      <div class="contentLeft">
        <p> <i class="el-icon-template"></i> 审图要点目录: </p>
        <div class="contentLeftTree">
          <el-input v-model="input" placeholder="请输入审图要点目录" size="small" class="input" />

          <el-tree ref="tree" class="LeftTree" :data="templateArr" node-key="id" :props="defaultProps"
            highlight-current :expand-on-click-node="false" :filter-node-method="filterNode" @node-click="clickNode">
            <template #default="{ node }">
              <span :title="node.label" class="el-tree-node__label">
                {{ node.label }}
              </span>
            </template>
          </el-tree>
        </div>
      </div>
      <div class="contentRignt">
        <p>
          <i class="el-icon-point"></i>
          审图要点:
        </p>
        <div class="contentRigntTree">
          <el-input v-model="pointInput" placeholder="请输入审图要点" size="small" class="pointInput" />
          <el-tree ref="pointTree" class="RightTree" :data="pointArr" node-key="id" :props="pointDefaultProps"
            highlight-current :expand-on-click-node="false" :filter-node-method="filterNodePoint"
            @node-click="clickPoint">
            <template #default="{ node,data}">
              <span :title="node.label" class="el-tree-node__label">
                <span v-if="data.pid=='0'">{{ data.itemIndex+1 }}.</span>
                {{ node.label }}
              </span>
            </template>
          </el-tree>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button type="primary" size="small" @click="choose">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import pointsService from "@/CommonDP/service/planApprovalPoints-service";
import { mapState } from "vuex";
export default {
  name: "Index",
  data() {
    return {
      loadPage: false,
      imgPoint: false,
      input: "",
      pointInput: "",
      templateArr: [],
      pointArr: [],
      defaultProps: { children: "list", label: "cnName", isLeaf: "leaf" },
      pointDefaultProps: { children: "list", label: "cnName", isLeaf: "leaf" },
      infoTemp: {}
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    input(val) {
      this.$refs.tree.filter(val);
    },
    pointInput(val) {
      this.$refs.pointTree.filter(val);
    }
  },
  methods: {
    async getAlldata() {
      this.loadPage = true;
      this._initTempClass();
    },
    showDialog() {
      this.imgPoint = true;
      this.getAlldata();
    },
    handleClose() {
      this.input = "";
      this.templateArr = [];
      this.pointArr = [];
      this.infoTemp = {};
      this.imgPoint = false;
      this.$parent.imgPoint = false;
    },
    async _initTempClass() {
      this.templateArr = [];
      const enterpriseId = this.$route.query.enterpriseId ? this.$route.query.enterpriseId : this.enterpriseId;
      const result = await pointsService.queryTemplate(enterpriseId, "", "0");
      this.templateArr = result.data;
      this.loadPage = false;
      this.$nextTick(() => {
        if (result.data[0]) {
          this.clickNode(result.data[0]);
        }
        this.$refs.tree.setCurrentKey(result.data[0].id);
      });
    },
    async clickNode(data) {
      this.pointArr = [];
      this.infoTemp = {};
      const result = await pointsService.queryTemplate(data.id, this.pointInput, "0");
      result.data.forEach((item, idenx) => {
        this.$set(item, "itemIndex", idenx);
      });
      this.pointArr = result.data;
      console.log(this.pointArr, "this.pointArr");
    },
    clickPoint(data) {
      this.infoTemp = data;
    },
    choose() {
      if (JSON.stringify(this.infoTemp) !== "{}") {
        this.$set(this.infoTemp, "mainPoint", this.infoTemp.cnName);
        this.$parent.getPointInfo(this.infoTemp);
        this.$message.success("已选择当前要点");
        this.handleClose();
      } else {
        this.$message.warning("请选择一条要点");
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.cnName.indexOf(value) !== -1;
    },
    filterNodePoint(value, data) {
      if (!value) return true;
      return data.cnName.indexOf(value) !== -1;
    }
  }
};
</script>

<style scoped lang="scss">
.box {
  display: flex;
  .contentLeft {
    width: 208px;
    margin-right: 14px;
    p {
      font-size: 16px;
      margin-bottom: 5px;
      .el-icon-template {
        background: url("./img/template.png") no-repeat;
        width: 17px;
        height: 17px;
      }

      .el-icon-template:before {
        content: "替";
        font-size: 13px;
        visibility: hidden;
      }
    }
    .contentLeftTree {
      border: 1px solid #d4d9ec;
      border-radius: 2px;
      .input {
        padding: 13px;
      }
      .el-tree-node__label {
        width: 208px;
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .LeftTree {
        height: 300px;
        overflow: auto;
      }
      .el-tree /deep/ .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
      }

      .el-tree /deep/ .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }

      //有子节点 且未展开
      // .el-tree /deep/ .el-icon-caret-right:before {
      //   background: url("./img/point.png") no-repeat 0 3px;
      //   content: "";
      //   display: block;
      //   width: 16px;
      //   height: 16px;
      //   font-size: 16px;
      //   background-size: 16px;
      // }

      // //有子节点 且已展开
      // .el-tree /deep/ .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
      //   background: url("./img/point.png") no-repeat 0 3px;
      //   content: "";
      //   display: block;
      //   width: 16px;
      //   height: 16px;
      //   font-size: 16px;
      //   background-size: 16px;
      // }

      //没有子节点
      // .el-tree /deep/ .el-tree-node__expand-icon.is-leaf::before {
      //   background: #fff;
      //   content: "";
      //   display: block;
      //   width: 16px;
      //   height: 16px;
      //   font-size: 16px;
      //   background-size: 16px;
      // }
    }
  }
  .contentRignt {
    width: calc(100% - 208px);
    p {
      font-size: 16px;
      margin-bottom: 5px;
      .el-icon-point {
        background: url("./img/point.png") no-repeat;
        width: 17px;
        height: 17px;
      }

      .el-icon-point:before {
        content: "替";
        font-size: 13px;
        visibility: hidden;
      }
    }
    .contentRigntTree {
      border: 1px solid #d4d9ec;
      border-radius: 2px;
      .pointInput {
        padding: 13px;
      }
      .el-tree-node__label {
        width: 100%;
        display: inline-block;
        white-space: pre-wrap;
        padding: 5px 0;
      }
      /deep/ .el-tree-node__content {
        height: auto !important;
      }
      .RightTree {
        height: 300px;
        overflow: auto;
      }
      // 点击展开以后
      .el-tree .el-tree-node__expand-icon.expanded {
        -webkit-transform: rotate(180deg);
        transform: rotate(180deg);
      }
      // 点击展开之前
      .el-tree .el-tree-node__expand-icon {
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }

      //有子节点 且未展开
      .el-tree .el-icon-caret-right:before {
        background: url("./img/top.png") no-repeat 0 3px;
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        font-size: 16px;
      }

      //有子节点 且已展开
      .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
        background: url("./img/top.png") no-repeat 0 3px;
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        font-size: 16px;
      }

      //没有子节点
      .el-tree .el-tree-node__expand-icon.is-leaf::before {
        background: #ffffff04;
        content: "";
        display: block;
        width: 16px;
        height: 16px;
        font-size: 16px;
      }
    }
  }
}
  // /deep/ .el-dialog {
  //   border-radius: 5px;
  //   position: relative;
  // }
  // /deep/ .el-dialog__body {
  //   padding: 0px 20px 20px;
  //   height: calc(100% - 74px);
  // }
</style>
